import { render, staticRenderFns } from "./PageInsBerth.vue?vue&type=template&id=76eae830&scoped=true&"
import script from "./PageInsBerth.vue?vue&type=script&lang=js&"
export * from "./PageInsBerth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76eae830",
  null
  
)

export default component.exports